/**
 * Created by zhj on 3/16/2016.
 */
'use strict';

angular.module('betosyswebapp')
  .controller('PendingCommandCtrl', function ($scope, commonTrackService, widgetSettingsCreatorService, $uibModalInstance, pendingCommandService, $timeout,errorHandlingService) {
    $scope.visibility = true;
    $scope.vehicleGroupComboBoxSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID',
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
      selectedIndex: 0,
      change: function (event) {
        var args = event.args;
        var vehicleGroupItem = $('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');
        if (args && vehicleGroupItem) {
          var groupId = vehicleGroupItem.value;
          loadVehicle(groupId);
        }
      }
    });

    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vehicleGroupList) {
        $scope.vehicleGroupComboBoxSettings.source = vehicleGroupList;
      });
    };

    var loadVehicle = function (groupId) {
      return commonTrackService.getVehicleListFilterByGroupId(groupId).then(function (vehicleList) {
        $scope.vehicleNameListBoxSettings.source = _.uniq(vehicleList, 'deviceID');
      });
    };

    $scope.vehicleNameListBoxSettings = {
      displayMember: 'description',
      valueMember: 'deviceID',
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
      checkboxes: true
    };

    $timeout(function () {
      $('#vehicleNameListBox').on('checkChange', function (event) {
        var item = event.args;
        if (item) {
          if (item.checked) {
            $timeout(function () {
              $scope.visibility = false;
            });
          } else {
            var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
            if (checkedItems.length === 0) {
              $timeout(function () {
                $scope.visibility = true;
              });
            } else {
              $scope.visibility = false;
            }
          }
        }
      });
    }, 0);

    loadVehicleGroup().then(function () {
      var vehicleGroupSource = $scope.vehicleGroupComboBoxSettings.source;
      if (vehicleGroupSource !== null && vehicleGroupSource !== undefined) {
        loadVehicle(vehicleGroupSource[0].groupID);
      }
    }).finally(function () {
      $scope.dataLoadingFinished = true;
    });

    $scope.selectAll = function () {
      $('#vehicleNameListBox').jqxListBox('checkAll');
    };

    $scope.deselectAll = function () {
      $('#vehicleNameListBox').jqxListBox('uncheckAll');
    };

    $scope.save = function () {
      var downloadParams = {
        deviceIds: [],
        commandType: 'config',
        commandID: 'TEL',
        sendState: 0
      };
      var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
      var deviceIds = [];
      for (var i = 0; i < checkedItems.length; i++) {
        var item = checkedItems[i];
        deviceIds.push(item.value);
      }
      downloadParams.deviceIds = deviceIds;
      pendingCommandService.downloadRequest(downloadParams).then(function () {
        $uibModalInstance.close();
      }, function (response) {
        $uibModalInstance.close();
        errorHandlingService.handleForCommonResponse(response);
      });
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/pendingCommandController.js